import React from "react";
import { Chip, Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// #951: substitui o DateRangePicker do MUI X Pro (pacote pago, usado sem
// licenca) por dois DatePicker da versao community. Mantem o contrato do
// Pro: value = [inicio, fim] e onChange(novoValor, { shortcut }).
// Precisa estar dentro de um LocalizationProvider.

const localeText = {
  fieldMonthPlaceholder: () => "mm",
  fieldDayPlaceholder: () => "dd",
  fieldYearPlaceholder: () => "aaaa",
};

const fieldSx = {
  "&& .MuiInputBase-root": { width: 170 },
};

const CompDateRangeFields = ({ value, onChange, shortcuts = [], disableFuture }) => {
  const [startDate, endDate] = value;

  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={1}>
        <DatePicker
          label="Início"
          value={startDate}
          onChange={(newValue) => onChange([newValue, endDate], {})}
          maxDate={endDate?.isValid() ? endDate : undefined}
          disableFuture={disableFuture}
          views={["year", "month", "day"]}
          openTo="day"
          localeText={localeText}
          slotProps={{ textField: { sx: fieldSx } }}
        />
        <DatePicker
          label="Fim"
          value={endDate}
          onChange={(newValue) => onChange([startDate, newValue], {})}
          minDate={startDate?.isValid() ? startDate : undefined}
          disableFuture={disableFuture}
          views={["year", "month", "day"]}
          openTo="day"
          localeText={localeText}
          slotProps={{ textField: { sx: fieldSx } }}
        />
      </Stack>
      {shortcuts.length > 0 && (
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {shortcuts.map((shortcut) => (
            <Chip
              key={shortcut.label}
              label={shortcut.label}
              size="small"
              variant="outlined"
              onClick={() => onChange(shortcut.getValue(), { shortcut })}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default CompDateRangeFields;
